import type { DashboardTab } from '@/features/dashboard/types';

/**
 * Extracts the first dashboard name and its tabs from a dashboards record.
 * Returns undefined values when the record is empty or nullish.
 */
export const extractFirstDashboard = (
  dashboards: Record<string, DashboardTab> | undefined
): { dashboardName: string | undefined; dashboardTabs: DashboardTab | undefined } => {
  if (!dashboards) return { dashboardName: undefined, dashboardTabs: undefined };
  const name = Object.keys(dashboards)[0];
  if (!name) return { dashboardName: undefined, dashboardTabs: undefined };
  return { dashboardName: name, dashboardTabs: dashboards[name] };
};
